var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", _vm._b({}, "a", { "xlink:href": _vm.link }, false), [
    _vm.shape.polygon
      ? _c("polygon", {
          key: "polygon-" + _vm.shape.id,
          staticClass: "c-illustration__shape",
          class: _vm.css,
          attrs: { points: _vm.shape.polygon },
          on: {
            mouseenter: function ($event) {
              return _vm.toggleFocus(true)
            },
            mouseout: function ($event) {
              return _vm.toggleFocus(false)
            },
            click: _vm.updateRouter,
          },
        })
      : _c("path", {
          key: "path-" + _vm.shape.id,
          staticClass: "c-illustration__shape",
          class: _vm.css,
          attrs: { d: _vm.shape.path },
          on: {
            mouseenter: function ($event) {
              return _vm.toggleFocus(true)
            },
            mouseout: function ($event) {
              return _vm.toggleFocus(false)
            },
            click: _vm.updateRouter,
          },
        }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }